// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__Q7yfU","nav":"Header_nav__2aqcp","link":"Header_link__2oysO","active":"Header_active__2LQpq"};